import { render, staticRenderFns } from "./MovieClassics.vue?vue&type=template&id=42246e69&scoped=true"
import script from "./MovieClassics.vue?vue&type=script&lang=js"
export * from "./MovieClassics.vue?vue&type=script&lang=js"
import style0 from "./MovieClassics.vue?vue&type=style&index=0&id=42246e69&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42246e69",
  null
  
)

export default component.exports